import { useAuthStore } from '../stores/auth'
import router from '../router'
import { JwtPayload, jwtDecode } from 'jwt-decode'
import { createURL } from '@/api/utils'

class StatusError {
  message: string
  status: any

  constructor(message: any, status: any) {
    this.message = message
    this.status = status
  }
}

export function parseToken(token: string): string {
  // falsy or malformed jwt will throw InvalidTokenError
  const data = jwtDecode<JwtPayload & { unique_name: string }>(token)

  document.cookie = `auth=${token}; Path=/; SameSite=Strict;`

  localStorage.setItem('jwt', token)

  const authStore = useAuthStore()
  authStore.jwt = token
  authStore.setUser(JSON.parse(data.unique_name))
  return token
}

export async function validateLogin(): Promise<string> {
  try {
    if (localStorage.getItem('jwt')) {
      return renew(<string>localStorage.getItem('jwt'))
    }
    return Promise.reject('Stored JWT token is not available')
  } catch (error) {
    console.warn('Invalid JWT token in storage') // eslint-disable-line
    return Promise.reject(error)
  }
}

export async function loginByUsername(username: string, password: string, recaptcha?: string) {
  return login({ username, password, recaptcha })
}

export async function loginByEmail(email: string, password: string, recaptcha?: string) {
  return login({ email, password, recaptcha })
}

export async function login(data: { email?: string; username?: string; password: string; recaptcha?: string }) {
  // parseToken(
  //   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyLCJ1c2VyIjoie1wiaWRcIjpcInRlc3RcIixcInVzZXJuYW1lXCI6XCJ0ZXN0XCIsXCJwYXNzd29yZFwiOlwidGVzdFwiLFwic2NvcGVcIjpcInRlc3RcIixcImxvY2FsZVwiOlwidGVzdFwiLFwibG9ja1Bhc3N3b3JkXCI6ZmFsc2UsXCJoaWRlRG90ZmlsZXNcIjpmYWxzZSxcInNpbmdsZUNsaWNrXCI6ZmFsc2UsXCJkYXRlRm9ybWF0XCI6ZmFsc2V9In0.Byt0XjK-0KqWy2Y-UTGGB6vXMkbqlDSdNajhfUZH8ms',
  // )
  const bodyFormData = new FormData()
  bodyFormData.append('Password', data.password)
  if (data.email) bodyFormData.append('Email', data.email)
  else if (data.username) bodyFormData.append('Username', data.username)

  const res = await fetch(createURL(`/api/auth/login`), {
    method: 'POST',
    body: bodyFormData,
  })

  const body = await res.text()

  if (res.status === 200) {
    parseToken(body)
  } else {
    throw new StatusError(body || `${res.status} ${res.statusText}`, res.status)
  }
}

export async function renew(jwt: string): Promise<string> {
  const res = await fetch(createURL(`/api/auth/renew`), {
    method: 'POST',
    headers: {
      Authorization: 'Bearer ' + jwt,
    },
  })

  const body = await res.text()

  if (res.status === 200) return parseToken(body)
  else throw new StatusError(body || `${res.status} ${res.statusText}`, res.status)
}

export async function signup(username: string, password: string) {
  const data = { username, password }

  const res = await fetch(createURL(`/api/signup`), {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  })

  if (res.status !== 200) {
    throw new StatusError(`${res.status} ${res.statusText}`, res.status)
  }
}

export function logout() {
  document.cookie = 'auth=; Max-Age=0; Path=/; SameSite=Strict;'

  const authStore = useAuthStore()
  authStore.clearUser()
  localStorage.setItem('jwt', '')
  router.push({ name: 'logout' })
}
